<template>
  <div class="top-bar color-scheme-dark position-fixed nav-rain" style="width: 100%; z-index: 99">
    <!--------------------START - Top Menu Controls -------------------->
    <div class="top-menu-controls hidden-mobile">
      <!--------------------  START - Settings Link in secondary top menu -------------------->

      <!-- Extensiones Telefónicas -->
      <div class=" messages-notifications os-dropdown-trigger os-dropdown-position-left " @click=" verExtensiones()"
        @mouseover="popUpTelTrue()" @mouseleave="popUpTelFalse()">
        <i class="os-icon os-icon-phone"></i><i class="status-pill green" style="font-size: 1px;"></i>
        <div v-if="popUpTel == true" class="new-messages-count">
          <span>Extensiones</span>
        </div>
      </div>
      <!-- Notificaciones -->
      <div class="
      messages-notifications
      os-dropdown-trigger os-dropdown-position-left" @mouseover="popUpNotiTrue()" @mouseleave="popUpNotiFalse()"
        @click="toggleNotificaciones">
        <i class="os-icon os-icon-bell"></i>
        <div class="new-messages-count" v-if="text2">
          <span>Notificaciones</span>
        </div>
      </div>
      <div v-if="showNotificaciones" class="notificaciones-list">
        <p style="font-size: 15px;"><i class="fas fa-cloud-moon"></i> &nbsp; No hay notificaciones nuevas</p>
      </div>
      <!-- Buzón -->
      <div class="
          messages-notifications
          os-dropdown-trigger os-dropdown-position-left
        " @click="buzonSugerencias" @mouseover="popupTrue()" @mouseleave="popupFalse()">
        <i class="os-icon os-icon-inbox"></i>
        <div v-if="text" class="new-messages-count">
          {{ text }}
        </div>
      </div>
      &nbsp;&nbsp;
      <!--------------------  END - Settings Link in secondary top menu -------------------->
      <div class="logged-user-w">
        <div class="logged-user-i">
          <div class="avatar-w">
            <img alt v-bind:src="user.image" />
          </div>
          <div class="logged-user-menu color-style-bright">
            <a>
              <div class="logged-user-avatar-info">
                <div class="avatar-w">
                  <img alt v-bind:src="user.image" />
                </div>
                <div class="logged-user-info-w">
                  <div class="logged-user-name" v-html="user.name"></div>
                  <div class="logged-user-role" v-html="user.email"></div>
                </div>
              </div>
            </a>
            <div class="bg-icon">
              <i class="os-icon os-icon-fingerprint"></i>
            </div>
            <ul>
              <li>
                <a href="/profile"><i class="os-icon os-icon-ui-46"></i><span>Configuraciones de Cuenta</span></a>
              </li>
              <li>
                <a href="#" @click="logout"><i class="os-icon os-icon-signs-11"></i><span>Cerrar Sesión</span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--------------------  START - User avatar and menu in secondary top menu -------------------->

      <!--------------------  END - User avatar and menu in secondary top menu -------------------->
    </div>
    <!--------------------END - Top Menu Controls -------------------->
  </div>
</template>

<script>
import Api from "@/services/Api"
export default {
  components: {},
  data() {
    return {
      text: "",
      text2: "",
      popUpTel: false,
      showTopMenuModule: false,
      showNotificaciones: false,
      rainInterval: null,
      user: {
        name: "",
        image: "",
        email: "",
      },
    };
  },
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      return this.$store.getters.modules;
    },
  },
  created() {
    this.user.name = localStorage.getItem("name");
    this.user.email = localStorage.getItem("email");
    this.user.image = localStorage.getItem("image");
  },
  props: {
    source: String,
  },
  mounted() {
    Api().get("obtener-festividad-dia")
     .then(response => {
        let icono = "";
        let animationEffect = false;
        
        icono = response.data.icono;
        animationEffect = response.data.animationEffect;
        if (animationEffect){
          // Función para crear copos de nieve
          const createAnimationRain = () => {
            const rainContainer = document.querySelector(".nav-rain"); // El contenedor donde se generarán los copos;
            if (!rainContainer) return;

            const icon = document.createElement('div');
            icon.textContent = icono; // El símbolo del copo de nieve
            icon.classList.add('emoji-fall');
            
            // Posición aleatoria para el copo de nieve
            icon.style.left = `${Math.random() * 100}vw`; // 100% del ancho
            icon.style.fontSize = `${Math.random() * 10 + 10}px`; // Tamaño aleatorio
            icon.style.animationDuration = `${Math.random() * 5 + 5}s`; // Duración aleatoria de la caída
            icon.style.animationDelay = `${Math.random() * 5}s`; // Retardo aleatorio para cada copo
        
            rainContainer.appendChild(icon);
            // Eliminar el copo de nieve después de que cae completamente
            setTimeout(() => {
              if (icon && icon.parentNode) {
                icon.remove();
              }
            }, 10000); // Los copos desaparecen después de 10 segundos
          };
          // Crear copos de nieve en intervalos
          this.rainInterval = setInterval(createAnimationRain, 350);
        }
     })
     .catch(() => {});
  },
  beforeDestroy() {
    if (this.rainInterval) {
      clearInterval(this.rainInterval);
    }
  },
  methods: {
    toggleNotificaciones() {
      this.showNotificaciones = !this.showNotificaciones;
    },
    popupFalse() {
      this.text = "";
    },
    popupTrue() {
      this.text = "Buzón";
    },
    popUpTelTrue() {
      this.popUpTel = true;
    },
    popUpTelFalse() {
      this.popUpTel = false;
    },
    popUpNotiTrue() {
      this.text2 = "Notificaciones";
    },
    popUpNotiFalse() {
      this.text2 = "";
    },
    buzonSugerencias() {
      let routeUrl = this.$router.resolve({
        name: "rrhh-buzon-suegerencias-public",
      });
      window.open(routeUrl.href, "_blank");
    },
    verExtensiones() {
      let routeUrl = this.$router.resolve({
        path: "/cat/extensiones-telefonicas/",
      });
      window.open(routeUrl.href, "_blank");
    },
    logout: function () {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("image");
      localStorage.removeItem("id_usuario");
      localStorage.removeItem("is_superuser");
      localStorage.removeItem("tipo_usuario");
      localStorage.removeItem("permisos");
      localStorage.removeItem("grupos");
      localStorage.removeItem("tiendas_usuario");
      localStorage.removeItem("secciones_permitidas");
      localStorage.removeItem("vistas_permitidas");
      this.$store.commit("SET_LAYOUT", "clean-layout");
      document.location.href = "/";
    },
    seleccionarModulo: function (currentMenu) {
      this.showTopMenuModule = false;
      this.$store.commit("SET_MODULE", currentMenu.name);
      this.$store.getters.module;
    },
  },
};
</script>
<style>
.logged-user-menu {
  margin-top: 57px;
  margin-right: 14px;
}

.notificaciones-list {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 100;
  margin-top: 112px;
  width: 300px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

  
  /* Copos de nieve */
  .emoji-fall {
    position: absolute;
    top: -10px;
    color: rgb(255, 255, 255);
    font-size: 1rem;
    user-select: none;
    pointer-events: none;
    opacity: 0.8;
    animation: fall linear infinite;
  }

  @keyframes fall {
    to {
      transform: translateY(6vh);
    }
  }
</style>
